import { Paper, Stack } from "@mui/material";
import React from "react";

export default function CustomTab({
  size = "medium",
  tabs = [],
  activeTab = "",
  onClick = () => {},
}) {
  return (
    <div className="flex justify-start">
      <Paper className="border-gray rounded-b-none">
        <Stack direction="row" spacing={0}>
          {tabs.map((tabItem) => (
            <div
              key={tabItem?.label}
              className={`${
                size === "small" ? "py-2 px-4" : "py-4 px-6"
              } cursor-pointer ${
                activeTab?.tab === tabItem?.tab
                  ? "bg-secondary rounded-t text-white"
                  : tabItem?.tab === tabs?.[tabs?.length - 1]?.tab
                  ? ""
                  : " menu-divider"
              }`}
              onClick={() => onClick(tabItem)}
            >
              <span>{tabItem?.label}</span>
            </div>
          ))}
        </Stack>
      </Paper>
    </div>
  );
}
